import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { blackBackArrowImage } from "../../assets";
import { CircularProgress } from "@material-ui/core";
import { invokeApi } from "../../bl_libs/invokeApi";
import { useSnakbar } from "../../Context/Context-Snakbar/ContextSnackbar";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

function Agreement(props) {
  const classes = useStyles();
  const { showErrorSnak } = useSnakbar();
  const signPad = React.useRef();

  const [letter, setLetter] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [expand, setExpand] = useState(true);
  const [reqId, setReqId] = useState("");

  const handleClick = () => {
    if (isChecked === false) {
      showErrorSnak("Please checked: Agree to terms and conditions.");
      return;
    }

    if (signPad.current.isEmpty()) {
      showErrorSnak("Please take signature on sign-pad");
      return;
    }

    const signature = signPad.current.getCanvas().toDataURL("image/png");

    AttachSignature(signature);
  };

  const handleRetakeSignature = () => {
    console.log(signPad.current.clear());
  };

  const GetAgreementDocuments = () => {
    let requestObj = {
      path: "/api/company/get_confirmation_letter",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.id}`,
    };

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        // setDocuments(res.request_document);
        setLetter(res.confirmation_letter);
        setReqId(res.get_request.id);
        setIsLoading(false);
      } else {
        showErrorSnak(res.message);
      }
    });
  };

  const AttachSignature = (sign) => {
    let requestObj = {
      path: "/api/company/attach_signature_make_confirmation_letter_pdf",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${reqId}`,
      signature_path: sign,
    };
    setIsLoading(true);
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        if (isNaN(props.match.params.id)) {
          props.history.push("/view-request/" + props.match.params.id);
        } else {
          props.history.push("/dashboard/my-requests/" + props.match.params.id);
        }
      } else {
        showErrorSnak(res.message);
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    GetAgreementDocuments();
  }, []);

  if (isLoading) {
    return (
      <>
        <section id="content-wrapper" className="content-wrapper calendar-page">
          <div className="container-fluid">
            <p className="small-text-bold page-title">Confirmation Letter</p>
            <div className="container-fluid">
              <div className="Circular-Progress">
                <CircularProgress />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Confirmation Letter</span>
          </p>

          <div className="rating-wrapper mt-40 mt-m-30">
            <div className="row justify-content-center">
              <div className="col-12 col-xl-10">
                <div className="" role="document">
                  <div className="rounded-box pb-30">
                    <div className="modal-header text-center border-0 pb-0"></div>
                    <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
                      <div className="modal-body pt-40">
                        <h5
                          className="text-center"
                          id="agreement-title"
                          onClick={() => {}}
                        >
                          Agreement
                        </h5>

                        <div className="row pt-1 agreement-separator no-gutters">
                          <div className="col-12">
                            <Accordion
                              expanded={expand}
                              onChange={() => setExpand(!expand)}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <div className="insurance_btn_text sub-title">
                                  Move Confirmation Letter
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: letter,
                                  }}
                                  style={{ width: "100%" }}
                                ></div>
                              </AccordionDetails>
                            </Accordion>
                          </div>
                        </div>

                        <div className="form-check">
                          <label className="mb-0 custom-checkbox-wrapper">
                            Agree to terms and conditions
                            <input
                              id="isStorage"
                              type="checkbox"
                              name="storage"
                              checked={isChecked}
                              onChange={() => setIsChecked(!isChecked)}
                            />
                            <span className="custom-check-box"></span>
                          </label>
                        </div>

                        <div className="row justify-content-center pt-20 pb-40">
                          <div className="col-12 text-center">
                            <SignatureCanvas
                              ref={signPad}
                              penColor="black"
                              canvasProps={{
                                width:
                                  window.innerWidth < 800
                                    ? window.innerWidth * 0.7
                                    : window.innerWidth * 0.5,
                                height: 250,
                                style: {
                                  border: "dashed 1px black",
                                },
                              }}
                            />
                          </div>
                          <div className="col-12 text-center pt-2">
                            <span
                              className="custom-link pointer-point mr-40"
                              onClick={handleRetakeSignature}
                            >
                              Clear Signature Pad
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-4 pb-40">
                            <button
                              type="button"
                              className="red-btn custom-buton custom-buton-large w-100 mt-40"
                              onClick={handleClick}
                            >
                              DONE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  */}
    </>
  );
}

export default Agreement;

// export default SignConfirmationLetter;
